import React from 'react';
import { ActionCardTitleDescSC } from './action-card-title-desc.styled';

interface ActionCardTitleDescProps {
  title?: React.ReactNode;
  description?: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}

const ActionCardTitleDesc: React.FunctionComponent<ActionCardTitleDescProps> = ({
  title,
  description,
  style,
  className,
}) => {
  return (
    <ActionCardTitleDescSC className={className} style={style}>
      {title ? <div className="ui-action-card-title">{title}</div> : null}
      {description ? <div className="ui-action-card-description">{description}</div> : null}
    </ActionCardTitleDescSC>
  );
};

export default ActionCardTitleDesc;
